import React from "react";
import { CONFIG } from "../config";

const COLUMNS = [
  {
    title: "Product",
    links: [
      { label: "XPTY", href: "#overview" },
      { label: "Platinum", href: "#platinum" },
      { label: "Transparency", href: "#transparency" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Xylapay", href: "#top" },
      { label: "Privacy", href: "#" },
      { label: "Terms", href: "#" },
      { label: "Contact", href: "#" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Whitepaper", href: CONFIG.whitepaperUrl || "#", download: true },
      { label: "Documentation", href: "#" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full border-t hairline bg-[#080909]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px] py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span
                className="overflow-hidden rounded-full shrink-0 w-8 h-8"
                style={{ border: "1px solid var(--hairline)" }}
              >
                <img
                  src="/logo-160.png"
                  alt="Xylapay"
                  className="w-full h-full object-cover"
                />
              </span>
              <span className="text-[15px] font-semibold text-[#F1F2EF] tracking-tight">
                {CONFIG.company}
              </span>
            </div>
            <p className="mt-6 max-w-[360px] text-[14px] leading-[1.6] text-[#A0A5A2]">
              {CONFIG.company} develops financial infrastructure for Real World
              Assets and blockchain-based settlement.
            </p>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <div className="micro-label">{col.title}</div>
                <ul className="mt-5 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        {...(l.download
                          ? { download: true, target: "_blank", rel: "noopener noreferrer" }
                          : {})}
                        className="text-[14px] text-[#A0A5A2] hover:text-[#F1F2EF] transition-colors duration-200"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t hairline flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <span className="text-[12px] text-[#6D726F]">
            © 2026 {CONFIG.company}. All Rights Reserved.
          </span>
          <span className="text-[11px] tracking-[0.16em] uppercase text-[#6D726F]">
            XPTY · Platinum RWA · v1.0
          </span>
        </div>
      </div>
    </footer>
  );
}
